module.exports = __webpack_public_path__ + "static/img/pamcardMob.c7a8a12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/common/hotsite/components/header/pamcardMob.svg
// module id = 1830
// module chunks = 1